import ja from '@vee-validate/i18n/dist/locale/ja.json'

const lang = {
  code: 'ja',
  messages: {
    ...ja.messages,
    required: '{_field_}を入力してください。',
    date_format: '{_field_}の書式が正しくありません。',
  },
}

export default lang
